import { render } from "./global.vue?vue&type=template&id=3d2ff6c2&scoped=true&ts=true"
import script from "./global.vue?vue&type=script&lang=ts"
export * from "./global.vue?vue&type=script&lang=ts"

import "./global.vue?vue&type=style&index=0&id=3d2ff6c2&scoped=true&lang=scss"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2ff6c2"]])

export default __exports__